import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ReactTooltip from 'react-tooltip';
import { CompanySelect } from "."
import {
  IconCompanies,
  IconOffers,
  IconInvestors,
  IconAccounts,
  IconLogout,
} from './../assets/images';
import { CompanyContext } from "./../contexts/CompanyContext";

import {
  logout,
} from "./../queries/user";

function SidebarNav() {
  const navigate  = useNavigate();
  const { selectedCompany } = React.useContext(CompanyContext);

  const logoutUser = () => {
    logout().then(
      () => {
        toast.success("Logged out.")
        navigate("/logout")
      },
      () => {
        toast.error("Something did not work.")
      }
    );

  }
  return (
    <div className="bg-dark" id="sidebar-wrapper">
      <div className="sidebar-nav">
        <CompanySelect />
        <NavLink  data-for="sidenavTooltip" data-tip="Company" to={`/companies/${selectedCompany.slug}`} end>
          <img src={IconCompanies} alt="company nav icon" />
        </NavLink>
        <NavLink  data-for="sidenavTooltip" data-tip="Offers" to={`companies/${selectedCompany.slug}/offers`}>
          <img src={IconOffers} alt="offers nav icon" />
        </NavLink>
        <NavLink  data-for="sidenavTooltip" data-tip="Investors" to={`companies/${selectedCompany.slug}/investors`}>
          <img src={IconInvestors} alt="investors nav icon" />
        </NavLink>
        <NavLink  data-for="sidenavTooltip" data-tip="Accounts" to={`companies/${selectedCompany.slug}/accounts`}>
          <img src={IconAccounts} alt="accounts nav icon" />
        </NavLink>
        <Link to="#" onClick={ logoutUser }className="nav-last-item">
          <img src={IconLogout} alt="logout icon" />
        </Link>
        <ReactTooltip id="sidenavTooltip" effect="solid" place="right" offset={{'right': 10}} backgroundColor="#111"/>
      </div>
    </div>
  )
}

export default SidebarNav;